import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/ClassAssembly/2024/12B/1.jpg';
// import p2 from 'assests/Photos/ClassAssembly/2024/12B/2.jpg';
// import p3 from 'assests/Photos/ClassAssembly/2024/12B/3.jpg';
// import p4 from 'assests/Photos/ClassAssembly/2024/12B/4.jpg';
// import p5 from 'assests/Photos/ClassAssembly/2024/12B/5.jpg';
// import p6 from 'assests/Photos/ClassAssembly/2024/12B/6.jpg';


// import p7 from 'assests/Photos/ClassAssembly/6D/7.jpg';





import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import ClassAssemblySidebar2025 from '../ClassAssemblySidebar2025';

const ClassAssembly10D2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });


  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2025}/home/events-activities/class-assembly/10D/1.webp`;
  const p2 = `${config.base_image_url_2025}/home/events-activities/class-assembly/10D/2.webp`;
  const p3 = `${config.base_image_url_2025}/home/events-activities/class-assembly/10D/3.webp`;
  const p4 = `${config.base_image_url_2025}/home/events-activities/class-assembly/10D/4.webp`;
  
 


  const photos = [
    
    {
      src: p1,
      source: p1,
      rows: 1,
      cols: 1,
    },
    {
      src: p2,
      source: p2,
      rows: 1,
      cols: 1,
    },
    {
        src: p3,
        source: p3,
        rows: 1,
        cols: 1,
      },
       {
      src: p4,
      source: p4,
      rows: 1,
      cols: 1,
    },
   
    // {
    //   src: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   source: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h5' align='center'>
     Agriculture and Youth  
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
    Class: 1OD Date: 7 & 8 July 2025

        </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        The students of class 10 D presented their class assembly on the topic AGRICULTURE AND YOUTH emphasizing the vital role of youth in the agricultural future of our nation. On 7 July 2025, he assembly began with a heartfelt original poem recitation, penned and performed by a student, that beautifully highlighted the bond between the soil and the soul, and the untapped potential of young minds in transforming the agricultural sector. This was followed by an impactful skit showcasing the challenges faced by farmers and how modern youth, equipped with technology and innovation, can bring about sustainable changes in farming. The skit used a strong message to drive home the importance of reconnecting with our roots. The presentation concluded with a lively dance performance set to folk music, celebrating the spirit of rural life and the energetic contribution of youth in shaping India’s agricultural narrative. Overall, The assembly was not only entertaining but also deeply inspiring, leaving the audience with a renewed respect for farmers and a strong sense of responsibility among the youth.  
        <br></br>
        
        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “The future of farming lies not in the soil alone, but in the hands of the youth who dare to sow innovation with tradition.”

<br/>
        </Typography>

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 200 : 100}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <ClassAssemblySidebar2025 />
             </Box>
             <Box marginBottom={4}>
               <Archive2022 />
             </Box>
           {/* <SidebarNewsletter /> */}
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default ClassAssembly10D2025;